export const LEADS_ROUTE = 'leads/:id/:cbTabRouteId';

export const viewLeadUrl = (leadId: string | number) => `leads/${leadId}/details`;
